<template>
  <div class="td big">
    <div class="site-picture" :style="{ backgroundImage: `url(${data.image})` }"></div>
    <span class="poi" :style="{ 'background-image': `url('${data.poi}')` }"></span>
    <div class="details">
      <span class="title">{{ data.name }}</span>

      <div v-if="optimizedTransport && !customTransport" class="matching-time-container wrap">
        <span class="matching-time">
          <i class="icon icon-bus"></i>
          {{ data.transportDistribution.optimized.public }}%
        </span>
        <span class="matching-time">
          <i class="icon icon-car"></i>
          {{ data.transportDistribution.optimized.car }}%
        </span>
        <span v-if="study.withWalkingTimes" class="matching-time">
          <i class="icon icon-cycle"></i>
          {{ data.transportDistribution.optimized.bicycle }}%
        </span>
        <span v-if="study.withWalkingTimes" class="matching-time">
          <i class="material-icons">directions_walk</i>
          {{ data.transportDistribution.optimized.walking }}%
        </span>
      </div>

      <div v-if="customTransport && !optimizedTransport" class="matching-time-container wrap">
        <span class="matching-time">
          <i class="icon icon-bus"></i>
          {{ data.transportDistribution.custom.public }}%
        </span>
        <span class="matching-time">
          <i class="icon icon-car"></i>
          {{ data.transportDistribution.custom.car }}%
        </span>
        <span class="matching-time">
          <i class="icon icon-cycle"></i>
          {{ data.transportDistribution.custom.bicycle }}%
        </span>
        <span v-if="study.withWalkingTimes" class="matching-time">
          <i class="material-icons">directions_walk</i>
          {{ data.transportDistribution.custom.walking }}%
        </span>
      </div>

      <span v-if="!optimizedTransport && !customTransport" class="address">{{ data.address }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['data'],

  computed: {
    ...mapGetters({
      study: 'study',
      globalFilters: 'globalFilters',
    }),

    optimizedTransport() {
      return (
        (this.data.forcedTransport !== 'public' &&
          this.data.forcedTransport !== 'private' &&
          this.globalFilters &&
          this.globalFilters.currentMatchingTime === 'optimized') ||
        this.data.forcedTransport === 'optimized'
      );
    },

    customTransport() {
      return (
        (this.data.forcedTransport !== 'public' &&
          this.data.forcedTransport !== 'private' &&
          this.globalFilters &&
          this.globalFilters.currentMatchingTime === 'custom') ||
        this.data.forcedTransport === 'custom'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.dark .td .matching-time-container .matching-time {
  font-size: 32px;
  color: white;
}

.td {
  display: flex;
  align-items: center;

  .poi {
    flex-shrink: 0;
    height: 5.375em;
    display: inline-block;
    width: 5em;
    background-size: contain;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    color: white;
    text-align: center;
    box-sizing: border-box;
    padding-top: 0.875em;
    font-weight: 700;
  }

  .site-picture {
    flex-shrink: 0;
    height: 7.0625em;
    width: 9.375em;
    border-radius: 0.625em;
    margin-left: 1.3em;
    margin-right: 1.3em;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .details {
    flex-shrink: 0;
    flex: 1;
    span {
      display: block;
      &.title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 1.75em;
        font-weight: 700;
      }
      &.address {
        font-size: 1.5em;
      }
    }
  }

  .matching-time-container {
    &.wrap {
      display: flex;
      flex-wrap: wrap;
    }

    .matching-time {
      width: 50%;
      font-size: 13px;
      color: colors.$concrete-color;

      .material-icons {
        font-size: 13px;
        margin-left: 0.25em;
        padding-bottom: 0.35em;
      }
    }
  }
}
</style>
